import { StatusRegisterResponse } from "@/main/models/response";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { useStyles } from "./styles";

interface Props {
	status: StatusRegisterResponse;
}

export default function StatusComponent(props: Props) {
	const classes = useStyles();

	const renderColor = () => {
		switch (props.status.idStatusRegister) {
			case StatusRegisterEnum.Active:
				return "#00cc66";
			case StatusRegisterEnum.Delete:
				return "#ff0000";
			case StatusRegisterEnum.Suspended:
				return "#ff9900";
			default:
				return "#00cc66";
		}
	};
	return (
		<div
			className={`d-flex align-items-center justify-content-center ${classes.container}`}
			title={props.status.name}
			style={{ backgroundColor: renderColor() }}
		>
			<span className={classes.spanContainer}>{props.status.name}</span>
		</div>
	);
}
